import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

const SkipStep = ({ onClickEvent, className }) => {
  return (
    <div
      className={classnames(styles.skipStepLink, className)}
      onClick={onClickEvent}>
      Skip Step
    </div>
  );
};

export default SkipStep;
